import {inlineError} from '@s-ui/decorators'

import UserFavoritesRepository from './UserFavoritesRepository.js'

/**
 * @interface
 */
export default class HTTPUserFavoritesRepository extends UserFavoritesRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.authenticationFetcher
   * @param {Object} deps.mapper
   */
  constructor({config, authenticationFetcher, fetchOrFail, mapper, unsubscribeFavoriteUserError}) {
    super()
    this._config = config
    this._authenticationFetcher = authenticationFetcher
    this._fetchOrFail = fetchOrFail
    this._mapper = mapper
    this._unsubscribeFavoriteUserError = unsubscribeFavoriteUserError
  }

  /**
   * @method
   * @param {Object} params
   * @param {String} params.userId - User ID
   * @return {Promise<UserFavoritesValueObject>}
   */
  get({userId}) {
    return this._authenticationFetcher
      .get(`${this._config.get('API_URL')}/v3/users/${userId}/favorites`)
      .then(response => this._mapper.map(response.data))
  }

  /**
   * @method
   * @return {Promise}
   */
  add({adId, userId, filteredProvinces}) {
    return this._authenticationFetcher.put(
      `${this._config.get('API_URL')}/users/${userId}/favorites/${adId}?filteredProvinces=${filteredProvinces}`
    )
  }

  addDealer({userId, contractId}) {
    return this._authenticationFetcher.put(
      `${this._config.get('API_URL')}/v3/users/${userId}/favorites/contracts/${contractId}`
    )
  }

  /**
   * @method
   * @return {Promise}
   */
  delete({adId, userId}) {
    return this._authenticationFetcher.delete(`${this._config.get('API_URL')}/users/${userId}/favorites/${adId}`)
  }

  /**
   * @method
   * @return {Promise}
   */
  deleteDealer({userId, contractId}) {
    return this._authenticationFetcher.delete(
      `${this._config.get('API_URL')}/v3/users/${userId}/favorites/contracts/${contractId}`
    )
  }

  @inlineError
  async unsubscribeFavorite({unsubscribeFavoriteRequest}) {
    const {adId, token, userId} = unsubscribeFavoriteRequest.toJSON()
    const tenant = this._config.get('TENANT')
    const {GENERIC} = this._config.get('COMMON').ERRORS

    const [error, response] = await this._fetchOrFail
      .withErrorsFactories({
        [GENERIC]: () => this._unsubscribeFavoriteUserError('Unsubscribe favorite user error')
      })
      .post(
        `${this._config.get('API_URL')}/${tenant}/unsubscribe/pricedrop/${userId}/${adId}?unsubscribetoken=${token}`
      )

    if (error) return Promise.reject(error)

    const {data} = response

    return Promise.resolve({data})
  }
}
